var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWarningIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    style: {
      height: 100,
      width: 100
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#F2AA3E",
    fillRule: "nonzero",
    d: "M17.899 16.75L9.649 2.5a.78.78 0 0 0-1.298 0L.101 16.75a.75.75 0 0 0 .649 1.125h16.5a.75.75 0 0 0 .649-1.125zM9.904 7.375l-.354 4.95h-1.1l-.334-4.95h1.789zM9 15.625a1.1 1.1 0 1 1 0-2.2 1.1 1.1 0 0 1 0 2.2z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarningIcon);
export default __webpack_public_path__ + "static/media/warning-icon.8e83cfb64eb566aed7b7dcd771f0cf3a.svg";
export { ForwardRef as ReactComponent };